import { defineMessages } from 'react-intl';

const translations = defineMessages({
  'project.index.title': {
    id: 'project.index.title',
    defaultMessage: 'Index Proyectos'
  },
  'project.noName': {
    id: 'project.noName',
    defaultMessage: 'Sin Nombre'
  },
  'project.noNameAbbreviated': {
    id: 'project.noNameAbbreviated',
    defaultMessage: 'SN'
  },
  'project.qualities.creationSuccess': {
    id: 'project.qualities.creationSuccess',
    defaultMessage: 'Calidad creada'
  },
  'project.delivery.creationSuccess': {
    id: 'project.delivery.creationSuccess',
    defaultMessage: 'Flete Solicitado'
  },
  'project.pricing.delivery.creationSuccess': {
    id: 'project.pricing.delivery.creationSuccess',
    defaultMessage: 'Cotización realizada'
  },
  'delivery.address.origin': {
    id: 'delivery.address.origin',
    defaultMessage: 'Dirección de Origen '
  },
  'delivery.address.destination': {
    id: 'delivery.address.destination',
    defaultMessage: 'Dirección de Destino '
  },
  'delivery.client.name': {
    id: 'delivery.client.name',
    defaultMessage: 'Nombre Cliente'
  },
  'delivery.client.phone': {
    id: 'delivery.client.phone',
    defaultMessage: 'Teléfono Cliente'
  },
  'delivery.description': {
    id: 'delivery.description',
    defaultMessage: 'Descripción de Carga'
  },
  'delivery.roundtrip': {
    id: 'delivery.roundtrip',
    defaultMessage: 'Viaje ida y vuelta'
  },
  'delivery.vehicle': {
    id: 'delivery.vehicle',
    defaultMessage: 'Tipo de vehículo'
  },
  'delivery.quote': {
    id: 'delivery.quote',
    defaultMessage: 'Cotizar'
  },
  'delivery.distance': {
    id: 'delivery.distance',
    defaultMessage: 'Distancia'
  },
  'delivery.project': {
    id: 'delivery.project',
    defaultMessage: 'Proyecto'
  },
  'delivery.cancelService': {
    id: 'delivery.cancelService',
    defaultMessage: 'Cancelar Servicio'
  },
  'delivery.myTasks': {
    id: 'delivery.myTasks',
    defaultMessage: 'Mis Tareas'
  },
  'delivery.today': {
    id: 'delivery.today',
    defaultMessage: 'Hoy'
  },
  'delivery.goTo': {
    id: 'delivery.goTo',
    defaultMessage: 'Ir a...'
  },
  'delivery.state': {
    id: 'delivery.state',
    defaultMessage: 'Estado'
  },
  'delivery.inProcess': {
    id: 'delivery.inProcess',
    defaultMessage: 'En Proceso'
  },
  'delivery.phone': {
    id: 'delivery.phone',
    defaultMessage: 'Teléfono'
  },
  'delivery.finalize': {
    id: 'delivery.finalize',
    defaultMessage: 'Finalizar'
  },
  'delivery.finalized': {
    id: 'delivery.finalized',
    defaultMessage: 'Finalizado'
  },
  'delivery.pending': {
    id: 'delivery.pending',
    defaultMessage: 'Pendiente'
  },
  'delivery.pendings': {
    id: 'delivery.pendings',
    defaultMessage: 'Pendientes'
  },
  'delivery.references': {
    id: 'delivery.references',
    defaultMessage: 'Referencias'
  },
  'delivery.pendingPlaceholder': {
    id: 'delivery.pendingPlaceholder',
    defaultMessage: 'Escoge un pendiente'
  },
  'delivery.start': {
    id: 'delivery.start',
    defaultMessage: 'Comenzar'
  },
  'delivery.reactivate': {
    id: 'delivery.reactivate',
    defaultMessage: 'Reactivar'
  },
  'delivery.address': {
    id: 'delivery.address',
    defaultMessage: 'Dirección'
  },
  'delivery.client': {
    id: 'delivery.client',
    defaultMessage: 'Cliente'
  },
  'delivery.provider': {
    id: 'delivery.provider',
    defaultMessage: 'Proveedor'
  },
  'delivery.cel': {
    id: 'delivery.cel',
    defaultMessage: 'Cel'
  },
  'delivery.executed': {
    id: 'delivery.executed',
    defaultMessage: 'Ejecución'
  },
  'delivery.images': {
    id: 'delivery.images',
    defaultMessage: 'Imagenes'
  },
  'delivery.comments': {
    id: 'delivery.comments',
    defaultMessage: 'Comentarios'
  },
  'delivery.commentPlaceholder': {
    id: 'delivery.commentPlaceholder',
    defaultMessage: 'Esrcribe cualquier tipo de información adicional al envio...'
  },
  'delivery.failed': {
    id: 'delivery.failed',
    defaultMessage: 'Fallido'
  },
  'delivery.success': {
    id: 'delivery.success',
    defaultMessage: 'Exitoso'
  },
  'delivery.noTasks': {
    id: 'delivery.noTasks',
    defaultMessage: 'No tienes ninguna tarea asignada'
  },
  'delivery.noReference': {
    id: 'delivery.noReference',
    defaultMessage: 'No Generar - Finalizar Visita'
  },
  'delivery.noReferenceAndFinalized': {
    id: 'delivery.noReferenceAndFinalized',
    defaultMessage: 'Sin Referencia y Finalizado'
  },
  'delivery.noReferenceAndFinalize': {
    id: 'delivery.noReferenceAndFinalize',
    defaultMessage: 'Generar - Finalizar Orden'
  },
  'delivery.notes': {
    id: 'delivery.notes',
    defaultMessage: 'Notas'
  },
  'delivery.associate': {
    id: 'delivery.associate',
    defaultMessage: 'Asociar'
  },
  'delivery.pause': {
    id: 'delivery.pause',
    defaultMessage: 'Pausar'
  },
  'delivery.all': {
    id: 'delivery.all',
    defaultMessage: 'Todos'
  },
  'delivery.day': {
    id: 'delivery.day',
    defaultMessage: 'Día'
  },
  'delivery.week': {
    id: 'delivery.week',
    defaultMessage: 'Semana'
  },
  'delivery.scheduledRoutes': {
    id: 'delivery.scheduledRoutes',
    defaultMessage: 'Rutas agendadas'
  },
  'delivery.noOrders': {
    id: 'delivery.noOrders',
    defaultMessage: 'No hay ordenes agendadas'
  },
  'delivery.unavailableProject': {
    id: 'delivery.unavailableProject',
    defaultMessage: 'No posee un proyecto asociado'
  },
  'delivery.tooltip.generate': {
    id: 'delivery.tooltip.generate',
    defaultMessage: 'Generar: '
  },
  'delivery.tooltip.doNotGenerate': {
    id: 'delivery.tooltip.doNotGenerate',
    defaultMessage: 'No generar: '
  },
  'delivery.tooltip.associate': {
    id: 'delivery.tooltip.associate',
    defaultMessage: 'Asociar: '
  },
  'delivery.tooltip.generateHelp': {
    id: 'delivery.tooltip.generateHelp',
    defaultMessage: 'Cambia estado de la orden a finalizado y genera encuesta postservicio.'
  },
  'delivery.tooltip.doNotGenerateHelp': {
    id: 'delivery.tooltip.doNotGenerateHelp',
    defaultMessage: 'Reporta agendamiento y no modifica estado de la orden.'
  },
  'delivery.tooltip.associateHelp': {
    id: 'delivery.tooltip.associateHelp',
    defaultMessage:
      'Asociar con documento de traslado existente. Una vez se registrada cantidad total ídem a orden se genera encuesta postservicio, y estado de pedido queda en finalizado'
  },
  'formik.search': {
    id: 'formik.search',
    defaultMessage: 'Buscar...'
  },
  'formik.loading': {
    id: 'formik.loading',
    defaultMessage: 'Cargando...'
  },
  'formik.requiredField': {
    id: 'formik.requiredField',
    defaultMessage: 'Este campo es obligatorio'
  },
  'formik.noOptions': {
    id: 'formik.noOptions',
    defaultMessage: 'No hay opciones'
  },
  'dropzone.uploadPhotos': {
    id: 'dropzone.uploadPhotos',
    defaultMessage: '+ Subir Fotos'
  },
  'dropzone.reject': {
    id: 'dropzone.reject',
    defaultMessage: 'Archivo no válido para subir.'
  },
  'dropzone.active': {
    id: 'dropzone.active',
    defaultMessage: 'Suelta los archivos aquí para subir...'
  },
  'dropzone.disabled': {
    id: 'dropzone.disabled',
    defaultMessage: 'Alcanzaste la cantidad máxima de archivos.'
  },
  'dropzone.tooLarge': {
    id: 'dropzone.tooLarge',
    defaultMessage: 'El archivo excede el peso máximo permitido'
  },
  unavailable: {
    id: 'unavailable',
    defaultMessage: 'No disponible'
  },

  // Unified login (UnifiedLogin screen + appUserAuth saga)
  'login.brand.titleLine1': { id: 'login.brand.titleLine1', defaultMessage: 'Un acceso,' },
  'login.brand.titleLine2': { id: 'login.brand.titleLine2', defaultMessage: 'todas tus cuentas.' },
  'login.brand.text': {
    id: 'login.brand.text',
    defaultMessage: 'Tu correo es la llave. Entra una vez y cambia entre los espacios de trabajo que compartes.'
  },
  'login.brand.foot': {
    id: 'login.brand.foot',
    defaultMessage: 'Acceso sin contraseña · verificación por código'
  },
  'login.email.eyebrow': { id: 'login.email.eyebrow', defaultMessage: 'Inicia sesión' },
  'login.email.title': { id: 'login.email.title', defaultMessage: 'Entra a Parrotfy' },
  'login.email.lead': {
    id: 'login.email.lead',
    defaultMessage: 'Escribe tu correo y te enviaremos un código de acceso de 6 dígitos.'
  },
  'login.email.label': { id: 'login.email.label', defaultMessage: 'Correo electrónico' },
  'login.email.placeholder': { id: 'login.email.placeholder', defaultMessage: 'tu@correo.com' },
  'login.email.invalid': { id: 'login.email.invalid', defaultMessage: 'Escribe un correo electrónico válido.' },
  'login.email.submit': { id: 'login.email.submit', defaultMessage: 'Continuar' },
  'login.legal': {
    id: 'login.legal',
    defaultMessage:
      'Al iniciar sesión aceptas nuestras <privacy>Políticas de Privacidad</privacy> y <terms>Términos de Servicio</terms>.'
  },
  'login.email.noAccount': {
    id: 'login.email.noAccount',
    defaultMessage: '¿No tienes cuenta? <signup>Crea una aquí</signup>'
  },
  'login.otp.back': { id: 'login.otp.back', defaultMessage: 'Cambiar correo' },
  'login.otp.title': { id: 'login.otp.title', defaultMessage: 'Revisa tu correo' },
  'login.otp.lead': { id: 'login.otp.lead', defaultMessage: 'Enviamos un código de 6 dígitos a' },
  'login.otp.resendQuestion': { id: 'login.otp.resendQuestion', defaultMessage: '¿No llegó el código?' },
  'login.otp.resend': { id: 'login.otp.resend', defaultMessage: 'Reenviar código' },
  'login.otp.resendWait': { id: 'login.otp.resendWait', defaultMessage: 'Reenviar en {time}' },
  'login.otp.error.expired': {
    id: 'login.otp.error.expired',
    defaultMessage: 'El código expiró. Pide uno nuevo para continuar.'
  },
  'login.otp.error.noTenants': {
    id: 'login.otp.error.noTenants',
    defaultMessage: 'Esta cuenta no tiene espacios de Parrotfy asociados.'
  },
  'login.otp.error.notFound': {
    id: 'login.otp.error.notFound',
    defaultMessage: 'No existe una cuenta con ese correo.'
  },
  'login.otp.error.invalid': {
    id: 'login.otp.error.invalid',
    defaultMessage: 'Código incorrecto. Revísalo e inténtalo otra vez.'
  },
  'login.status.suspended': { id: 'login.status.suspended', defaultMessage: 'Suspendido' },
  'login.status.pending': { id: 'login.status.pending', defaultMessage: 'Pendiente' },
  'login.status.active': { id: 'login.status.active', defaultMessage: 'Activo' },
  'login.tenant.overdueDays': { id: 'login.tenant.overdueDays', defaultMessage: '{days} días de mora' },
  'login.tenant.title': { id: 'login.tenant.title', defaultMessage: 'Elige una cuenta' },
  'login.tenant.search': { id: 'login.tenant.search', defaultMessage: 'Buscar empresa…' },
  'login.tenant.empty': { id: 'login.tenant.empty', defaultMessage: 'No encontramos empresas para “{query}”.' },
  'login.tenant.footInfo': {
    id: 'login.tenant.footInfo',
    defaultMessage: 'Las cuentas se agrupan por tu correo - la fuente única de verdad.'
  },
  'login.support.title': { id: 'login.support.title', defaultMessage: 'Acceso de soporte' },
  'login.support.lead': {
    id: 'login.support.lead',
    defaultMessage: 'Ingresa el subdominio de la empresa a la que quieres entrar.'
  },
  'login.support.label': { id: 'login.support.label', defaultMessage: 'Subdominio' },
  'login.support.placeholder': { id: 'login.support.placeholder', defaultMessage: 'empresa' },
  'login.support.submit': { id: 'login.support.submit', defaultMessage: 'Entrar' },
  'login.emailchip.change': { id: 'login.emailchip.change', defaultMessage: 'Cambiar' },
  'login.overlay.entering': { id: 'login.overlay.entering', defaultMessage: 'Entrando a {name}' },
  'login.overlay.loading': { id: 'login.overlay.loading', defaultMessage: 'Cargando tus empresas…' },
  'login.overlay.cancel': { id: 'login.overlay.cancel', defaultMessage: 'Cancelar' },
  'login.reason.inactive': {
    id: 'login.reason.inactive',
    defaultMessage: 'Tu cuenta no está activa en esa empresa. Contacta a tu administrador.'
  },
  'login.reason.timeout': {
    id: 'login.reason.timeout',
    defaultMessage: 'Tu sesión expiró. Inicia sesión nuevamente.'
  },
  'login.reason.unauthenticated': {
    id: 'login.reason.unauthenticated',
    defaultMessage: 'Inicia sesión para continuar.'
  },
  'login.reason.locked': {
    id: 'login.reason.locked',
    defaultMessage: 'Tu cuenta está bloqueada. Contacta a soporte.'
  },
  'login.reason.unconfirmed': {
    id: 'login.reason.unconfirmed',
    defaultMessage: 'Debes confirmar tu cuenta antes de continuar.'
  },
  'login.error.connection': {
    id: 'login.error.connection',
    defaultMessage: 'No pudimos conectar con el servidor. Revisa tu conexión e inténtalo nuevamente.'
  },
  'login.error.server': {
    id: 'login.error.server',
    defaultMessage: 'Ocurrió un problema. Inténtalo nuevamente en unos minutos.'
  },
  'login.error.tenantRedirect': {
    id: 'login.error.tenantRedirect',
    defaultMessage: 'No pudimos acceder a esa empresa. Inténtalo nuevamente.'
  }
});

export default translations;
